import React, { useState } from "react";
import "../../css/Common.css";
import { Link } from "react-router-dom";
import { FaAngleDown, FaAngleUp, FaChevronRight } from "react-icons/fa";
import { address, email, phone } from "../../constants";
import logo from "../../images/credu_loan_logo.png";
const Footer = () => {
  const [dropdown1, setDropdown1] = useState(false);
  const [dropdown2, setDropdown2] = useState(false);
  const [dropdown3, setDropdown3] = useState(false);
  return (
    <>
      <div className="footer_wrapper full-width">
       
       
        <div className="copyright_section text-white">
          <p style={{marginBottom:'0px'}}>
            Copyright ©  Paradox Finance Pvt. Ltd. All Rights Reserved.
          </p>
        </div>
        
      </div>
    </>
  );
};

export default Footer;
